import getAppliedGiftcards from '../selectors/GiftCardSelectors/getAppliedGiftcards';
import getGiftcardFormData from '../selectors/GiftCardSelectors/getGiftcardFormData';
import * as types from './action-types';
import {getUpdatedAppliedGiftcards} from './getUpdatedAppliedGiftcards';

export const handleAppliedGiftcards = orderSummary => (dispatch, getState) => {
  const appliedGiftcardsInState = getAppliedGiftcards(getState());
  let updatedAppliedGiftcards = [...appliedGiftcardsInState];
  const giftcardFormData = getGiftcardFormData(getState());
  if (appliedGiftcardsInState.length < orderSummary.giftCardSummaries.length) { // apply giftcard
    orderSummary.giftCardSummaries.forEach((giftcard) => {
      if (appliedGiftcardsInState.find(appliedGiftcard => appliedGiftcard.cardUUID === giftcard.cardUUID)
        === undefined) {
        updatedAppliedGiftcards = [...updatedAppliedGiftcards, {
          cardNumber: giftcardFormData.giftcardNumber,
          cardPin: giftcardFormData.giftcardPin,
          cardUUID: giftcard.cardUUID,
          amountApplied: giftcard.amountApplied,
          amountLeft: giftcard.amountLeft,
          expiryDate: giftcard.expiryDate,
          paymentMethod: giftcard.paymentMethod,
        }];
      }
    });
  }
  
  if (appliedGiftcardsInState.length > orderSummary.giftCardSummaries.length) { // remove giftcard
    updatedAppliedGiftcards
      .filter(appliedGiftcard => orderSummary.giftCardSummaries
        .find(giftcard => giftcard.cardUUID === appliedGiftcard.cardUUID) === undefined);
  }
  
  updatedAppliedGiftcards = [...getUpdatedAppliedGiftcards(orderSummary, updatedAppliedGiftcards)];
  dispatch({type: types.ADD_APPLIED_GIFTCARD_TO_STATE, updatedAppliedGiftcards});
};
